import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getCurrentIdentity } from '../userIdentity';

const Groups = () => {
  const [inviteCode, setInviteCode] = useState('');
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentIdentity().then(id => {
      if (id?.userId) setUserId(id.userId);
    });
  }, []);

  const handleJoin = async () => {
    if (!inviteCode.trim() || !userId) return;

    try {
      const res = await fetch('/api/groups/join', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, inviteCode })
      });
      
      const data = await res.json();
      if (data.success) {
        alert('Вы успешно зашли в группу');
        navigate(`/chat/${data.chatId}`);
      } else {
        alert(data.error || 'Ошибка');
      }
    } catch (err) {
      alert(`Ошибка: ${err.message}`);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', p: 2 }}>
      <Typography variant="h6" color="text.secondary" sx={{ fontStyle: 'italic', mb: 4 }}>
        Здесь вы можете вступить в группу для игры в днд
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, maxWidth: 400, width: '100%' }}>
        <TextField
          label="Введи код группы"
          variant="outlined"
          fullWidth
          value={inviteCode}
          onChange={(e) => setInviteCode(e.target.value)}
          sx={{ '& .MuiFormLabel-root': { fontStyle: 'italic' } }}
        />
        <Button 
          variant="contained" 
          onClick={handleJoin}
          sx={{ borderRadius: '10px' }}
        >
          Вступить
        </Button>
      </Box>
    </Box>
  );
};

export default Groups;